import { InboxRequestError } from './inbox-request-error';

export type InboxSummary = { enabled: boolean; pending: number };
export type InboxSummaryEntry = InboxSummary & {
  checkedAt: number;
  failed: boolean;
};

export async function refreshInboxSummary(
  previous: InboxSummaryEntry | undefined,
  request: () => Promise<InboxSummary>,
  now = Date.now
): Promise<InboxSummaryEntry> {
  try {
    return { ...(await request()), failed: false, checkedAt: now() };
  } catch (error) {
    // Preserve an open review on network/5xx failures, never on revoked access.
    // Every mutation is still authorized independently by the backend.
    const revoked =
      error instanceof InboxRequestError && [401, 403].includes(error.status);
    return {
      enabled: !revoked && Boolean(previous?.enabled),
      pending: !revoked ? previous?.pending || 0 : 0,
      failed: true,
      checkedAt: now(),
    };
  }
}
